interface GetDomainParameters {
  path?: string;
  protocol?: 'http' | 'https';
}

const getDomain = (parameters?: GetDomainParameters) => {
  let url = '';

  if (parameters?.protocol) {
    url += `${parameters.protocol}://`;
  }

  if (process.env.APIM_DOMAIN_HOST) {
    url += process.env.APIM_DOMAIN_HOST;
  }

  if (parameters?.path) {
    url += parameters.path;
  }

  return url;
};

export default getDomain;
